<template>
  <div id="HSTRequest">
    <section>
      <div id="container-center">
        <form>
        <h1 style="" class="title has-text-centered printTarget">睡眠検査機器配送ｻｰﾋﾞｽ（解析結果付）申込み</h1>
        <div>
          <b-steps v-model="activeStep" :animated="true" :rounded="true" :has-navigation="false" label-position="bottom">
            <b-step-item step="1" label="利用規約" icon="comment-alert-outline" v-if="needAgree">
              <div id="item-contens">
                <div class="request-title">
                  <b-button class="is-primary" style="float:left;" icon-left="home" @click.prevent="goHome">ホーム画面 </b-button>
                  <b-button class="is-primary" style="float: right" icon-right="chevron-double-right" :disabled="!isChecked" @click.prevent="Forward">次へ</b-button>
                  <span>以下の利用規約に同意のうえ、申込みを行ってください。</span>
                </div>
                <div class="card-content margin-top">
                  <span style="font-size:20px;">利用規約</span>
                  <table>
                    <tr><td><textarea readonly class="cautionArea noresize" v-model="agreement" /></td></tr>
                    <tr>
                        <td>
                          <div style="text-align: center;">
                            「<a :href="getUrlRentalCondition()" target="_blank" rel="noopener noreferrer">レンタルの一般条件</a>」は<a :href="getUrlRentalCondition()" target="_blank" rel="noopener noreferrer" style="font-weight: bold;color:yellowgreen">こちら</a>を参照してください。 「<a :href="getUrlPrivacyPolicy()" target="_blank" rel="noopener noreferrer">プライバシー規則</a>」は<a :href="getUrlPrivacyPolicy()" target="_blank" rel="noopener noreferrer" style="font-weight: bold;color:yellowgreen">こちら</a>を参照してください。
                          </div>
                        </td>
                    </tr>
                    <tr><td><div style="text-align: center;"></div></td></tr>
                    <tr><td><div style="text-align: center;"><b-checkbox class="cstmCheckBox" v-model="isChecked" :disabled="!canAgree">利用規約に同意のうえ、申込みを行う。</b-checkbox></div></td></tr>
                  </table>
                </div>
              </div>
            </b-step-item>
            <b-step-item step="2" label="基本情報" icon="clipboard-edit-outline">
              <div id="item-contens">
                <div class="request-title">
                  <b-button v-if="needAgree" class="is-primary" style="float:left;" icon-left="chevron-double-left" @click.prevent="Backward">前へ</b-button>
                  <b-button v-else class="is-primary" style="float:left;" icon-left="home" @click.prevent="goHome">ホーム画面 </b-button>
                  <b-button class="is-primary" style="float:right;" icon-right="chevron-double-right" :disabled="!isHospitalAgree" @click.prevent="Forward">次へ</b-button>
                  <span>申込み内容を入力してください。</span>
                </div>
                <div class="card-content margin-top">
                  <table>
                    <tr><th>医療機関名<span class="require" v-if="isDealer || isHonsha || isAdmin || isSalesOffice"/></th>
                      <td>
                        <template v-if="isDealer || isHonsha || isAdmin || isSalesOffice">
                          <input type="text" style="width:730px;" v-model="reqParams.hospitalName" class="2" name="医療機関名" validate="required" disabled />
                          <b-button style="margin-left:10px; width:150px; height:27px;" @click="organizationModalActive=true">医療機関選択</b-button>
                        </template>
                        <template v-else>{{reqParams.hospitalName}}</template>
                      </td>
                    </tr>
                    <tr><th>医師名</th><td><input type="text" v-model="reqParams.doctorName" maxlength="105"/></td></tr>
                    <tr><th>事務担当者名</th><td><input type="text"  v-model="reqParams.clerkName" maxlength="100"/></td></tr>
                    <tr v-if="isHonsha || isAdmin || isSalesOffice"><th>コメント</th><td>{{reqParams.note}}</td></tr>
                    <template v-if="isDealer">
                      <tr><th>医療機関メールアドレス</th><td><b-checkbox class="cstmCheckBox" v-model="reqParams.isResultMailSend">解析結果のダウンロードURLを医療機関にメールで通知する。</b-checkbox></td></tr>
                      <tr v-if="reqParams.isResultMailSend"><th></th><td><input type="text" v-model="reqParams.hospitalMail" maxlength="256" placeholder="例）example@example.com" class="2" name="医療機関メールアドレス" validate="mail|required"></td></tr>
                    </template>
                    <tr><th>機種<span class="require" name="item_step2" id="model"/></th><td><select id="model" class="2" name="機種" validate="required" v-model="reqParams.model" @change="changeModel" :disabled="!reqParams.hospitalName || modelList.length <= 1"><option v-for="model in modelList" :value="model.value" :key="model.value">{{ model.label1 }}</option></select></td></tr>
                    <tr v-if="reqParams.model == '7'">
                      <th></th>
                      <td v-if="!disabledSnoreSensor"><b-checkbox class="cstmCheckBox" v-model="reqParams.snoreSensor" :disabled="disabledSnoreSensor">いびきセンサーあり</b-checkbox></td>
                      <td v-else style="display: flex;"><b-checkbox class="cstmCheckBox" :class="{snoreSensorCheckBox: !reqParams.snoreSensor}" v-model="reqParams.snoreSensor" :disabled="disabledSnoreSensor"></b-checkbox><div style="margin-left: -20px;">いびきセンサーあり</div></td>
                    </tr>
                    <tr v-if="reqParams.hospitalName && modelList.length <= 1"><th></th><td>現在、ご契約済の機種はございません。営業担当にお問い合わせください。</td></tr>
                    <tr v-else><th></th><td>スリーププロファイラーは、年齢に関わらず成人ルールでの解析となります。</td></tr>
                    <tr>
                      <th>最短出荷日</th>
                      <td>
                        <p>{{ earliestShippingDate }}</p>
                      </td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>
                        <p style="font-size: 14px;">
                          現時点での最短出荷日の目安となります。<br>
                          確定出荷日は申込完了時の画面でご確認ください。
                        </p>
                      </td>
                    </tr>
                    <tr><th>機器配送先<span class="require"/></th><td>
                      <div class="block">
                        <b-radio class="td_radio" name="target"  v-model="reqParams.delivaryTarget" native-value="home">患者宅に配送する</b-radio>
                        <b-radio class="td_radio" name="target"  v-model="reqParams.delivaryTarget" native-value="hospital">医療機関に配送する</b-radio>
                      </div></td>
                    </tr>
                    <template v-if="reqParams.delivaryTarget== 'hospital'">
                      <tr><th>【機器配送先】</th>
                      <tr>
                        <th>郵便番号<span class="require" /></th>
                        <td>
                          <input
                            id="zip"
                            v-model="reqParams.zip"
                            style="width: 270px"
                            class="2"
                            :class="{'border-red': invalidDeviceDestinationPostcode}"
                            name="機器配送先の郵便番号"
                            validate="required|numeric|zip"
                            type="tel"
                            maxlength="7"
                            :placeholder="postcodePlaceholder"
                            @blur="onZipBlur(reqParams.zip, 'digitErrorPostcode')"
                          />
                          <b-button
                            style="margin-left: 10px; width: 150px; height: 27px"
                            v-on:click="addressSearch('device', reqParams.zip)"
                          >
                          自動入力</b-button>
                          <div v-show="invalidDeviceDestinationPostcode" class="text-red">{{ invalidNumberMessage }}</div>
                          <div v-show="digitErrorPostcode" class="text-red">{{ digitErrorZipMessage }}</div>
                        </td>
                      </tr>
                      <tr><th>住所（都道府県、市町村区）<span class="require" style="margin-left:-8px;"/></th><td><input type="text" v-model="reqParams.address" class="2" name="機器配送先の住所（都道府県、市町村区）" validate="required" maxlength="280"/></td></tr>
                      <tr><th>住所（それ以降の住所）<span class="require"/></th><td><input type="text" v-model="reqParams.address1" class="2" name="機器配送先の住所（それ以降の住所）" validate="required" maxlength="256" ref="address1"/></td></tr>
                      <tr><th>住所（建物名、部屋番号）</th><td><input type="text" v-model="reqParams.address2" maxlength="256"/></td></tr>
                      <tr><th>宛名<span class="require"/></th><td><input type="text" v-model="reqParams.receiverName" maxlength="100" class="2" name="機器配送先の宛名" validate="required"/></td></tr>
                      <tr>
                        <th>連絡先(電話番号)<span class="require" /></th>
                        <td>
                          <input
                            v-model="reqParams.phoneNumber"
                            class="2"
                            :class="{'border-red': invalidDeviceDestinationPhoneNumber}"
                            validate="required|numeric"
                            name="機器配送先の連絡先(電話番号)"
                            type="tel"
                            maxlength="11"
                            :placeholder="phonePlaceholder"
                          />
                          <div v-show="invalidDeviceDestinationPhoneNumber" class="text-red">{{ invalidNumberMessage }}</div>
                        </td>
                      </tr>
                      <tr><th>配達希望時間帯</th><td><select v-model="reqParams.desiredDeliveryTimeZone" ><option v-for="timeZone in desiredDeliveryTimeZoneList" :value="timeZone.value" :key="timeZone.value">{{ timeZone.label1 }}</option></select></td></tr>
                    </template>
                    <template v-if="isHonsha || isAdmin || isSalesOffice">
                      <tr><th>【結果送付先】</th></tr>
                      <tr>
                        <th>郵便番号<span class="require" /></th>
                        <td>
                          <input
                            id="resultZip"
                            v-model="reqParams.resultZip"
                            style="width: 270px"
                            class="2"
                            :class="{'border-red': invalidResultDestinationPostcode}"
                            name="結果送付先の郵便番号"
                            validate="required|numeric|zip"
                            type="tel"
                            maxlength="7"
                            :placeholder="postcodePlaceholder"
                            @blur="onZipBlur(reqParams.resultZip, 'digitErrorResultPostcode')"
                          /><b-button
                            style="margin-left: 10px; width: 150px; height: 27px"
                            v-on:click="addressSearch('result', reqParams.resultZip)"
                            >自動入力</b-button
                          >
                          <div v-show="invalidResultDestinationPostcode" class="text-red">{{ invalidNumberMessage }}</div>
                          <div v-show="digitErrorResultPostcode" class="text-red">{{ digitErrorZipMessage }}</div>
                        </td>
                      </tr>
                      <tr><th>住所<span class="require"/></th><td><input type="text" v-model="reqParams.resultAddress" maxlength="280" class="2" name="結果送付先の住所" validate="required" ref="resultAddress"/></td></tr>
                      <tr><th>住所（建物名、部屋番号）</th><td><input type="text" v-model="reqParams.resultBuildingName" maxlength="256"/></td></tr>
                      <tr><th>医療機関名(会社名)</th><td><input type="text" placeholder="宛名を個人宛にする場合、医療機関名(会社名）はこちらに入力してください。" v-model="reqParams.resultCompanyName" maxlength="256"/></td></tr>
                      <tr><th>診療科(部署名)</th><td><input type="text" placeholder="宛名を個人宛にする場合、診療科(部署名）はこちらに入力してください。" v-model="reqParams.resultDivision" maxlength="100"/></td></tr>
                      <tr><th>宛名<span class="require"/></th><td><input type="text" placeholder="宛名に医療機関(会社名)を入れる場合、「医療機関名(会社名)」「診療科(部署名)」欄は空欄にしてください。" v-model="reqParams.resultReceiverName" maxlength="100" class="2" name="結果送付先の宛名" validate="required"/></td></tr>
                      <tr>
                        <th>連絡先(電話番号)<span class="require" /></th>
                        <td>
                          <input
                            v-model="reqParams.resultPhoneNumber"
                            class="2"
                            :class="{'border-red': invalidResultDestinationPhoneNumber}"
                            name="結果送付先の連絡先(電話番号)"
                            validate="required|numeric"
                            type="tel"
                            maxlength="11"
                            :placeholder="phonePlaceholder"
                          />
                          <div v-show="invalidResultDestinationPhoneNumber" class="text-red">{{ invalidNumberMessage }}</div>
                        </td>
                      </tr>
                    </template>
                    <tr><th class="deliverySlip_label">納品書</th>
                      <td>
                        <div>
                          <b-radio class="td_radio deliverySlip_radio" name="deliverySlip" v-model="reqParams.deliverySlip" :native-value="true">必要</b-radio>
                          <b-radio class="td_radio deliverySlip_radio" name="deliverySlip" v-model="reqParams.deliverySlip" :native-value="false">不要</b-radio>
                        </div>
                      </td>
                    </tr>
                    <tr><th>デモ</th><td><b-checkbox v-model="reqParams.demo" class="cstmCheckBox" @input="setModelList">デモ(トライアル)</b-checkbox></td></tr>
                    <template v-if="isDealer">
                      <tr/>
                      <tr>
                        <th/><td><b-checkbox class="cstmCheckBox" v-model="isHospitalAgree">申請者が睡眠検査機器配送ｻｰﾋﾞｽ（解析結果付）の申込みを行うことについて、該当医療機関の同意を取得しています。</b-checkbox></td>
                      </tr>
                    </template>
                  </table>
                </div>
              </div>
            </b-step-item>
            <b-step-item step="3" label="患者情報" icon="account">
              <div id="item-contens" v-bind:key="renderKey">
                <div class="request-title">
                  <b-button class="is-primary" style="float:left;" icon-left="chevron-double-left"  @click.prevent="Backward">前へ</b-button>
                  <b-button class="is-primary" style="float:right;" icon-right="chevron-double-right" @click.prevent="Forward">次へ</b-button>
                  <span>患者の情報を入力してください。</span>
                </div>
                <template v-for="(patient, index) in reqParams.patientsData">
                  <div class="card-content margin-top" :key="index">
                    <table>
                      <tr v-if="index > 0">
                        <td colspan="2">
                          <b-button style="float:right; width:27px; height:27px; border:none;" icon-left="close-box-outline" @click="deletePatient(index)"></b-button>
                        </td>
                      </tr>
                      <tr><th>診察券ID（患者ID）<span class="require" /></th><td><input type="text" v-model="patient.patientId" @input="patient.patientId = $event.target.value.replace(/^\s+/, '')" maxlength="50" class="3" :name="index+1+'番目、診察券ID（患者ID）'" validate="required" /></td></tr>
                      <tr><th>患者名<span class="require" /></th><td><input type="text" style="margin-right: 5px; width: 446px !important;" placeholder="姓" v-model="patient.patientFamilyName" class="3" :name="index+1+'番目、患者名(姓)'" validate="required|patientName" maxlength="49"/><input type="text" style="width: 446px !important;" placeholder="名" v-model="patient.patientFirstName" class="3" :name="index+1+'番目、患者名(名)'" validate="required|patientName" maxlength="49" @blur="focusLostPatientFirstName(index)"/></td></tr>
                      <tr><th>患者名（カナ）<span class="require" /></th><td><input type="text" style="margin-right: 5px; width: 446px !important;" placeholder="セイ ※匿名の場合は「トクメイ」と入力してください。" v-model="patient.patientFamilyNameKana" class="3" :name="index+1+'番目、患者名カナ(セイ)'" validate="required|patientNameKana" maxlength="49"/><input type="text" style="width: 446px !important;" placeholder="メイ ※匿名の場合は「トクメイ」と入力してください。" v-model="patient.patientFirstNameKana" class="3" :name="index+1+'番目、患者名カナ(メイ)'" validate="required|patientNameKana" maxlength="49"/></td></tr>
                      <tr><th>性別<span class="require" /></th><td>
                        <div class="block">
                          <b-radio size="is-small" v-model="patient.gender" native-value="-">-</b-radio>
                          <b-radio size="is-small" v-model="patient.gender" native-value="男">男</b-radio>
                          <b-radio size="is-small" v-model="patient.gender" native-value="女">女</b-radio>
                        </div></td>
                      </tr>
                      <tr><th>生年月日<span class="require"/></th><td><input type="date" v-model="patient.birthday" :input="inputBirthday(patient.birthday,index)" class="3" :name="index+1+'番目、患者の生年月日'" validate="required|date|birthDay" :max="yyyy_hyp_MM_hyp_dd(new Date())" style="width:150px;"/><span v-if="patient.birthday" style="margin-left:10px;">{{patient.japaneseCalendar}}</span></td></tr>
                      <tr><th>年齢</th><td><input type="text" disabled v-model="patient.age"/></td></tr>
                      <template v-if="isSW()">
                        <tr><th>カニューラサイズ<span class="require"/></th><td><select v-model="patient.cannulaSize" class="3" :name="index+1+'番目、患者のカニューラサイズ'" validate="required"><option v-for="cannulaSize in cannulaSizeList" :value="cannulaSize.value" :key="cannulaSize.value">{{ cannulaSize.label1 }}</option></select></td></tr>
                        <tr><th>ベルトサイズ<span class="require"/></th><td><select v-model="patient.beltSize" class="3" :name="index+1+'番目、患者のベルトサイズ'" validate="required"><option v-for="beltSize in beltSizeList" :value="beltSize.value" :key="beltSize.value">{{ beltSize.label1 }}</option></select></td></tr>
                        <tr><th></th>
                            <td>
                              <span style="font-size:12px;">サイズ選択の目安（身長・体重等も考慮してお選びください。） 
                                <br>　カニューラサイズ：小児用（ ～12歳）、成人用 （13歳以上）
                                <br>　ベルトサイズ：S_70cm（～5歳）、M_100cm（6歳～12歳）、L_130cm（13歳以上）
                              </span>
                            </td>
                        </tr>
                        <tr><th>添付波形<span class="require"/></th><td><select v-model="patient.attachedWaveform" class="3" :name="index+1+'番目、患者の添付波形'" validate="required"><option v-for="attachedWaveform in attachedWaveformList" :value="attachedWaveform.value" :key="attachedWaveform.value">{{ attachedWaveform.label1 }}</option></select></td></tr>
                      </template>
                      <tr><th>次回受診日</th><td><input type="date" v-model="patient.nextDate" class="3" :name="index+1+'番目、患者の次回受診日'" validate="date|notPastDay" style="width:150px;" :min="yyyy_hyp_MM_hyp_dd(new Date())"/></td></tr>
                      <tr><th></th><td><span style="font-size:12px;">次回受診日までの結果返却を保証するものではありません</span></td></tr>
                      <template v-if="reqParams.delivaryTarget== 'home'">
                        <tr>
                          <th>郵便番号<span class="require" /></th>
                          <td>
                            <input
                              :id="`zip_${index}`"
                              v-model="patient.zip"
                              style="width: 270px"
                              class="3"
                              :class="{'border-red': patient.invalidPostcode}"
                              :name="index + 1 + '番目、患者の郵便番号'"
                              validate="required|numeric|zip"
                              type="tel"
                              maxlength="7"
                              :placeholder="postcodePlaceholder"
                              @blur="onZipBlur(patient.zip, patient)"
                            />
                            <b-button
                              style="margin-left: 10px; width: 150px; height: 27px"
                              v-on:click="patientAddressSearch(index, patient.zip)"
                            >自動入力</b-button>
                            <div v-show="patient.invalidPostcode" class="text-red">{{ invalidNumberMessage }}</div>
                            <div v-show="patient.digitErrorPatientPostcode" class="text-red">{{ digitErrorZipMessage }}</div>
                          </td>
                        </tr>
                        <tr><th>住所（都道府県、市町村区）<span class="require" style="margin-left:-8px;"/></th><td><input type="text" v-model="patient.address" maxlength="256" class="3" :name="index+1+'番目、患者の住所（都道府県、市町村区）'" validate="required"/></td></tr>
                        <tr><th>住所（それ以降の住所）<span class="require"/></th><td><input type="text" :id="`address1_${index}`" v-model="patient.address1" maxlength="256" class="3" :name="index+1+'番目、患者の住所（それ以降の住所）'" validate="required"/></td></tr>
                        <tr><th>住所（建物名、部屋番号）</th><td><input type="text" v-model="patient.address2" maxlength="256"/></td></tr>
                        <tr><th>宛名<span class="require"/></th><td><input type="text" v-model="patient.receiverName" maxlength="100" class="3" :name="index+1+'番目、患者の宛名'" validate="required"/></td></tr>
                        <tr>
                          <th>連絡先（携帯優先）<span class="require" /></th>
                          <td>
                            <input
                              v-model="patient.phoneNumber"
                              class="3"
                              :class="{'border-red': patient.invalidPhoneNumber}"
                              :name="index + 1 + '番目、患者の連絡先（自宅または携帯）'"
                              validate="required|numeric"
                              type="tel"
                              maxlength="11"
                              :placeholder="phonePlaceholder"
                            />
                            <div v-show="patient.invalidPhoneNumber" class="text-red">{{ invalidNumberMessage }}</div>
                          </td>
                        </tr>
                        <tr><th></th><td><span style="font-size:12px;">携帯電話（スマートフォン）をお持ちの場合は、携帯電話（スマートフォン）の番号をご入力ください。検査受付完了時および機器が未返却の場合に、<br>ショートメッセージが自動送信されます。</span></td></tr>
                        <tr><th>配達希望時間帯</th><td><select v-model="patient.desiredDeliveryTimeZone" ><option v-for="timeZone in desiredDeliveryTimeZoneList" :value="timeZone.value" :key="timeZone.value">{{ timeZone.label1 }}</option></select></td></tr>
                      </template>
                      <tr><th>備考、その他、注意事項</th><td><textarea v-model="patient.memo" maxlength="256" style="resize:vertical;max-width:100%;"></textarea></td>
                    </tr>
                  </table>
                </div>
                </template>
                <div class="card-content margin-top">
                    <table>
                      <tr>
                        <th style="vertical-align:top;">注意事項</th>
                        <td>出荷日は「配送情報」で設定します。なお患者情報を複数人設定した場合でも出荷日は同一日となります。</td>
                      </tr>
                    </table>
                </div>
                <div class="margin-top">
                  <b-button v-if="!preKind" style="width:100%;background:#6191eb; color:black;" @click="addPatient" >患者を追加する</b-button>
                </div>
              </div>
            </b-step-item>
            <b-step-item step="4" label="配送情報" icon="truck">
              <div id="item-contens">
                <div class="request-title">
                  <b-button class="is-primary" style="float:left;" icon-left="chevron-double-left" @click.prevent="Backward">前へ</b-button>
                  <span>配送の情報を入力してください。</span>
                  <b-button class="is-primary" style="float:right;" icon-right="chevron-double-right" @click.prevent="Forward">次へ</b-button>
                </div>
                <div class="card-content margin-top">
                  <table>
                    <!-- <tr><th>最短出荷可能日</th><td>{{yyyy_sla_MM_sla_dd(miniday)}}</td></tr> -->
                    <tr><th style="vertical-align:top;">出荷日<span class="require"/></th>
                      <td>
                        <input type="date" v-model="reqParams.shippingDate"  class="shippingDate 4"  name="出荷日" validate="required|date" disabled style="width:150px;"/><a @click="officeCalenderActive = true"><b-icon icon="calendar-cursor"></b-icon></a>
                        <br/><span style="font-size: 14px;">※最短出荷日はカレンダーで選択可能な日になります。</span>
                      </td>
                    </tr>
                    <tr><th>返却日</th><td>{{reqParams.returnDate}}</td></tr>
                    <tr>
                      <th>備考、その他、注意事項</th>
                      <td>
                        <textarea v-model="reqParams.memo" maxlength="256" style="resize:vertical;max-width:100%;"></textarea>
                        <br/><span style="font-size: 14px;">※大変申し訳ございませんが、着日指定のコメントを記載いただいても、対応できかねますので、予めご了承ください。</span>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </b-step-item>
            <b-step-item step="5" label="申込み" icon="cloud-upload">
              <div id="item-contens">
                <div class="request-title">
                  <b-button class="is-primary" style="float:left;" icon-left="chevron-double-left" @click.prevent="Backward" >前へ</b-button>
                  <span>以下の申込み内容を確認のうえ、下部の「申込みを完了する」ボタンを押下してください。</span>
                </div>
                <!-- HST申込み詳細 -->
                <hstRequestDetail v-bind:data="reqParams" v-bind:key="renderKey"/>
                <b-button class="is-primary" style="margin-top:5px;width:250px;" @click="requestHst">申込みを完了する</b-button>
              </div>
            </b-step-item>
            <b-step-item step="6" label="完了" icon="check" :type="{'is-success': true}">
              <section class="unPrintTarget">
                <div class="request-title"><span>睡眠検査機器配送ｻｰﾋﾞｽ（解析結果付）の申込みを受け付けました。</span></div>
                <div class="request-title" v-if="needAgree"><span style="color:red;">翌営業日までに登録済みメールアドレスへ申し込み完了メールが送信されます。</span></div>
                <div class="margin-top">
                  <b-button class="backbutton is-primary" @click="back">戻る</b-button>
                  <b-button class="printbutton is-primary" icon-left="printer" @click="print">印刷</b-button>
                </div>
              </section>
              <section class="printTarget">
                <div id="item-contens">
                  <div class="card-content margin-top printMargin">
                    <table>
                      <tr><th>受付日時</th><td>{{requestDate}}</td></tr>
                      <tr><th>受付番号</th><td>{{receiptNumber}}</td></tr>
                    </table>
                  </div>
                </div>
                <hstRequestDetail v-bind:data="reqParams" v-bind:key="renderKey"/>
              </section>
            </b-step-item>
          </b-steps>
        </div>
        </form>
      </div>
    </section>
    <b-modal :active.sync="organizationModalActive" has-modal-card>
      <organizationSelectModal v-if="isSalesOffice || isHonsha || isAdmin" :selectRole="[role.role_hospital]" :selectStatus="extUserStatus.registed" :serviceId="serviceId" title="医療機関選択" labelForOrg="医療機関名" @select="setOrganization"></organizationSelectModal>
      <facilitySelectModal v-if="isDealer" :dealerId="userId" @select="setfacility"></facilitySelectModal>
    </b-modal>
    <b-modal :active.sync="officeCalenderActive" has-modal-card>
      <officeCalenderModal :miniday="miniday" :maxDay="maxday" :disabledDays="disabledDays" @select="setShippingDate" @change-page="changePage"></officeCalenderModal>
    </b-modal>
  </div>
</template>
<script>
import {
  role,
  consentStatement,
  choicesType,
  hstModelValue,
  extUserStatus,
  LendingPeriod,
  invalidNumberMessage,
  postcodePlaceholder,
  phonePlaceholder,
  digitErrorZipMessage,
} from "@/components/mock/base/const.js";
import hstRequest from "@/components/mock/common/HSTRequestDetail";
import OrganizationSelectModal from "@/components/mock/philips/common/OrganizationSelectModal";
import FacilitySelectModal from "@/components/mock/philips/common/FacilitySelectModal";
import OfficeCalenderModal from "@/components/mock/guest/OfficeCalenderModal";
import {service} from "@/components/mock/base/const.js";
const HOLIDAY_JP = require("@holiday-jp/holiday_jp");
const PH_HOLIDAYS = require('@/components/mock/base/philipsHollday.json');

const initialPatientValue = {
  patientId: "",
  patientFamilyName: "",
  patientFirstName: "",
  patientFamilyNameKana: "",
  patientFirstNameKana: "",
  gender: "-",
  birthday: "",
  age: "",
  zip: "",
  japaneseCalendar: "",
  phoneNumber: "",
  invalidPostcode: false,
  invalidPhoneNumber: false,
  digitErrorPatientPostcode: false,
};

const estimateSnoreSensorCode = { 
  noEstimate: 0, 
  onlyWithoutSensor:1,
  onlyWithSensor: 2,
  both:3
};

export default {
  name: "HSTRequest",
  methods: {
    Backward: function() {
      this.activeStep -= 1;
    },
    isSW: function() {
      var model = this.modelList.find(val => val.value == this.reqParams.model)
      if(model && model.label1 && model.label1.match(/スマートウォッチ/)){
        return true
      }
      return false
    },
    Forward: function(event) {
      // バリデーションチェック
      var stepItems = document.getElementsByClassName("step-item")
      var target
      for(var item of stepItems){
        if(item.getAttribute("style") != "display: none;"){
          target = item
        }
      }
      var activeStep = target ? target.getAttribute("step") : ""
      if(activeStep){
        var elements = document.getElementsByClassName(activeStep)
        var result = this.selfMadeValidation(elements)
        if(result.isError){
          this.showErrorMessage(result.msg)
        }else{
          // 再レンダリングの為、フラグ切替
          this.renderKey = !this.renderKey
          this.activeStep += 1;
        }
      }
    },
    requestHst: function() {
      var messsage
      var model = this.modelList.find(val => val.value == this.reqParams.model)
      messsage = model.label1+"の検査を申込みます。<br/>申込み内容、機種が正しいことを確認して「OK」ボタンを押してください。<br/>お申込み後のキャンセルは申請一覧より該当受付番号右端のメールボタンからキャンセル依頼をお願いします。"
      this.$dialog.confirm({
        title: "申込み確認",
        message: messsage,
        cancelText: "修正する",
        onConfirm: async () => {
          this.compleateFlg = false;
          var excuteApi = this.setHstApplicationPOST;
          var successCallBack = this.setHstApplicationPOSTSuccess;
          var errorCallBack = this.setHstApplicationPOSTError;
          // WebAPI Call
          await this.apiCall(excuteApi, successCallBack, errorCallBack)
          if(this.compleateFlg && this.requestDate && this.receiptNumber){
            this.jumpToTop();
            this.activeStep += 1;
          }
          else {
          this.showErrorMessage("申込みの登録処理に失敗しました。\n再度「完了」のボタンをクリックしてください。\nこのメッセージが繰り返し表示される場合は、Philips営業担当者にご連絡ください。");
          }
        }
      });
    },
    back: function() {
      // 転院紹介の場合
      if(this.preReceiptNumber) {
        this.$router.push({ path: "/guest/kensaMenu" });
      }else{
        this.$router.go(-1);
      }
    },
    goHome: function() {
      if (this.userInfo.belongsId) {
        this.$router.push({ path: "/guest/kensaMenu" });
      } else {
        this.back();
      }
    },
    addPatient: function() {
      this.reqParams.patientsData.push({ ...initialPatientValue });
      this.reqParams.shippingDate = "";
      this.reqParams.returnDate = "";
      // QA476 追加患者の郵便番号検索
      const index = this.reqParams.patientsData.length - 1;
      const item = this.reqParams.patientsData[index];
      this.$watch(() => item.zip,
        async (newZip) => {
          if (!newZip || newZip.length !== 7) return;
          if (isNaN(Number(newZip))) return;
          await this.patientAddressSearch(index, newZip);
          // 検索後に住所欄へフォーカス
          this.$nextTick(() => {
            var address1 = document.getElementById(`address1_${index}`);
            address1.focus();
          });
        }
      );
    },
    deletePatient: function(index) {
      this.reqParams.patientsData.splice(index, 1);

      this.reqParams.shippingDate = "";
      this.reqParams.returnDate = "";
    },
    changeModel: async function() {
      var _this = this
      this.reqParams.shippingDate = ""
      this.reqParams.returnDate = ""

      // 機種のリストに入力できる候補がない場合、機種をリセットしリターン
      if(this.modelList.length <= 1){
        this.reqParams.model = ""
        this.earliestShippingDate = ""
        return
      }
      
      // 機種のリストに設定できない機種がセットされている場合、機種をリセットしリターン
      let dispModelList = this.modelList.filter(data => { return data.value == this.reqParams.model });
      if(dispModelList.length <= 0){
        this.reqParams.model = ""
        this.earliestShippingDate = ""
        return
      }

      //最短出荷日の変更
      var model = this.modelList.find(val => val.value == this.reqParams.model)
      if(model && model.label1 && model.label1.match(/スリーププロファイラー/)){
        //●SP　　：翌々営業日後まで選択できない（申込時点から3営業日目は選択可能）
        await this.getBusinessDayPOST(null, 3, function(result) {
          _this.miniday = new Date(result.obj.date)
        })
      } else {
        //●SP以外：翌営業日まで選択できない　　（申込時点から2営業日目は選択可能）
        await this.getBusinessDayPOST(null, 2, function(result) {
          _this.miniday = new Date(result.obj.date)
        })
      }
      // 基本情報ステップの最短出荷日を算出
      if(this.reqParams.model) {
        this.earliestShippingDate = await this.calculateEarliestShippingDate();
      } else {
        this.earliestShippingDate = "";
      }
    },
    async calculateEarliestShippingDate() {
      let fromDate = new Date(this.miniday.getFullYear(), this.miniday.getMonth(), 1);
      let stockCalendar = [];
      let earliestDate = null;
      let earliestDateString = "";

      let THIS = this;
      let addMonthCount = 0;
      this.$root.$children[0].loadingStart();
      while(true) {
        let requestDate = new Date(fromDate.setMonth(fromDate.getMonth() + addMonthCount));

        await this.apiCall(
          function(client){
            return client.apis.internalShipmentCalendar.getStockCalendarPOST({
              body: {
                startDate: THIS.yyyy_sla_MM_sla_dd(requestDate),
                modelId: THIS.reqParams.model
              }
            });
          },
          function(result){
            stockCalendar = result.obj;
            for(var i = 0; i < stockCalendar.length; i++) {
              let day = stockCalendar[i];
              let formattedDate = fromDate.getFullYear() + "/" + day.date.replace("-", "/");
              if(THIS.isDisabledDay(new Date(formattedDate), fromDate, new Date(fromDate.getFullYear(), fromDate.getMonth() + 1, 0))) {
                continue;
              }
              if(THIS.reqParams.patientsData.length <= day.stock) {
                earliestDate = new Date(formattedDate);
                break;
              }
            }
          },
          function(result){
            THIS.showErrorMessage(result);
          }
        );

        if(earliestDate || stockCalendar.length == 0) {
          break;
        } else {
          fromDate.setMonth(fromDate.getMonth() - addMonthCount);
          addMonthCount++;
        }
      }
      this.$root.$children[0].loadingEnd();

      if(earliestDate) {
        earliestDateString = this.yyyy_sla_MM_sla_dd(earliestDate);
      } else {
        earliestDateString = "出荷可能な日程がありません";
      }

      return earliestDateString;
    },
    isDisabledDay(date, fromDate, toDate) {
      if(date < this.miniday || date > this.maxDay) {
        return true;
      }
      if (date.getDay() == 0 || date.getDay() == 6) {
        return true;
      }

      let formattedDay = this.yyyy_hyp_MM_hyp_dd(date);
      let holidays = HOLIDAY_JP.between(fromDate, toDate);
      for(var d of holidays) {
        if (formattedDay == this.yyyy_hyp_MM_hyp_dd(d.date)) {
          return true;
        }
      }

      if(PH_HOLIDAYS.everyyear.includes(this.MM_hyp_dd(date))|| PH_HOLIDAYS.irregular.includes(formattedDay)) {
        return true;
      }

      return false;
    },

    setShippingDate: function(selectDate){
      this.reqParams.shippingDate = selectDate
      this.shippingDateInput();
      this.officeCalenderActive = false;
    },
    changePage: function(sDate, eDate) {
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.internalShipmentCalendar.getStockCalendarPOST({
            body: {
              startDate: sDate,
              modelId: _this.reqParams.model
            }
          });
        },
        function(result){
          var disabled = result.obj.filter(data => {
            return data.stock < _this.reqParams.patientsData.length
          })
          _this.disabledDays = disabled
        },
        function(result){
          _this.showErrorMessage(result);
        }
      );
    },
    shippingDateInput: function() {
      // 返却日 = 出荷日+3週間(21日)
      var workDate = new Date(this.reqParams.shippingDate);
      workDate = this.getBusinessDay(workDate, this.lendingPeriod);
      this.reqParams.returnDate = this.yyyy_sla_MM_sla_dd(workDate);
    },
    setOrganization: async function(organizationInfo){
      this.isInitialZip = true;
      this.isInitialResultZip = true;
      this.reqParams.belongsId = organizationInfo.id + "";
      this.reqParams.hospitalName = organizationInfo.orgName;

      this.reqParams.receiverName = organizationInfo.orgName;
      this.reqParams.resultReceiverName = organizationInfo.orgName;

      this.reqParams.zip = organizationInfo.zip;
      this.reqParams.address = organizationInfo.prefecture + organizationInfo.city;
      this.reqParams.address1 = organizationInfo.address;
      this.reqParams.address2 = organizationInfo.building ? organizationInfo.building : "";
      this.reqParams.phoneNumber = organizationInfo.phoneNumber;

      this.reqParams.resultZip = organizationInfo.zip;
      this.reqParams.resultAddress = organizationInfo.prefecture + organizationInfo.city + organizationInfo.address;
      this.reqParams.resultBuildingName = organizationInfo.building ? organizationInfo.building : "";
      this.reqParams.resultPhoneNumber = organizationInfo.phoneNumber;
      this.reqParams.note = organizationInfo.note;
      
      if (!this.belongsId || this.belongsId != organizationInfo.id) {
        // 代理申込時
        this.belongsId = organizationInfo.id
      }

      // 見積りコードが紐づいた機種を取得・設定
      await this.getChoicesListLinkedEstimate()

      // 前回申込み情報の取得
      this.prevHstSearchParam.belongsId = this.belongsId
      await this.getPreviousApplication()
    },
    setfacility: async function(facility){
      this.isInitialZip = true;
      this.isInitialResultZip = true;
      this.reqParams.institutionId = facility.id + "";
      this.reqParams.hospitalName = facility.orgName;

      this.reqParams.receiverName = facility.orgName;
      this.reqParams.resultReceiverName = facility.orgName;

      this.reqParams.zip = facility.postcode;
      this.reqParams.address = facility.prefecture + facility.address;
      this.reqParams.address1 = facility.houseNumber;
      this.reqParams.address2 = facility.building ? facility.building : "";

      // 見積りコードが紐づいた機種を取得・設定
      await this.getChoicesListLinkedEstimate()

      // 前回申込み情報の取得
      this.prevHstSearchParam.institutionId = facility.id
      await this.getPreviousApplication()
    },
    getChoicesListLinkedEstimate: function() {
      var excuteApi = this.getChoicesListLinkedEstimatePOST;
      var successCallBack = this.getChoicesListLinkedEstimatePOSTSuccess;
      var errorCallBack = this.getChoicesListLinkedEstimatePOSTError;
      // WebAPI Call
      return this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getChoicesListLinkedEstimatePOST: function(client){
      let belongId = this.reqParams.belongsId? this.reqParams.belongsId: this.belongsId
      let institutionId = this.reqParams.institutionId? this.reqParams.institutionId: 0

      return client.apis.apiCommon.getChoicesListLinkedEstimatePOST({
        body: {
          belongId: belongId,
          institutionId: institutionId
        }
      });
    },
    getChoicesListLinkedEstimatePOSTSuccess: async function(result) {
      //機種リストをAPIからの取得値から抽出
      this.modelListLinkedEstimate = result.obj.filter(data => { return data.choicesType == this.choicesType.hstKind });
      this.modelListLinkedEstimate.unshift({})

      //WP300のいびきセンサーの見積りが紐づく項目をAPIからの取得値から抽出
      let estimateWP300Sensor =  result.obj.filter(data => { return data.choicesType == this.choicesType.WP300SnoreSensor });
      let estimateNoSensor = estimateWP300Sensor.filter(data => { return data.value == 1 });
      let estimateSensor = estimateWP300Sensor.filter(data => { return data.value == 2 });

      //いびきセンサーの見積り紐づき状態を設定
      if (estimateNoSensor.length <= 0 && estimateSensor.length <= 0){
        this.estimateSnoreSensorState = estimateSnoreSensorCode.noEstimate
      } else if (estimateNoSensor.length > 0 && estimateSensor.length <= 0) {
        this.estimateSnoreSensorState = estimateSnoreSensorCode.onlyWithoutSensor
      } else if (estimateNoSensor.length <= 0 && estimateSensor.length > 0) {
        this.estimateSnoreSensorState = estimateSnoreSensorCode.onlyWithSensor
      } else {
        this.estimateSnoreSensorState = estimateSnoreSensorCode.both
      }
      
      await this.setModelList(this.reqParams.demo)
    },
    getChoicesListLinkedEstimatePOSTError: function(result){
      this.showErrorMessage(result);
    },
    setModelList: async function(isDemo){
      if(this.reqParams.hospitalName){
        if(isDemo){
          // 選択肢マスタの機種を設定
          this.modelList = await this.getChoiceList(this.choicesType.hstKind, false);
          this.modelList.unshift({})
          // いびきセンサーのチェックボックスを非活性
          this.disabledSnoreSensor = false
          // いびきセンサーの有無をfalse
          this.reqParams.snoreSensor = false
        } else {
          // 見積りコードが紐づいている機種を設定
          this.modelList = this.modelListLinkedEstimate
          // いびきセンサーの有無の値と活性状態を更新
          switch(this.estimateSnoreSensorState){
            case estimateSnoreSensorCode.noEstimate:
            case estimateSnoreSensorCode.onlyWithoutSensor:
              this.disabledSnoreSensor = true
              this.reqParams.snoreSensor = false
              break
            case estimateSnoreSensorCode.onlyWithSensor:
              this.disabledSnoreSensor = true
              this.reqParams.snoreSensor = true
              break
            case estimateSnoreSensorCode.both:
              this.disabledSnoreSensor = false
              this.reqParams.snoreSensor = false
              break
          }
        }
        await this.changeModel()
      }
    },
    print: function(){
      window.print();
    },
    inputBirthday: function(birthday,index){
      var age = this.getAge(birthday)
      if(!isNaN(Number(age))){
        this.reqParams.patientsData[index].age = age < 0 ? 0 : age

        const date = new Date(birthday);
        const options = {era: 'long'};
        this.reqParams.patientsData[index].japaneseCalendar = "【"+this.getJapaneseCalendar(date)+"】"
      }else{
        this.reqParams.patientsData[index].age = ""
      }
    },
    setHstApplicationPOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.reqParams));
      obj.shortestShippingDate = this.yyyy_sla_MM_sla_dd(this.miniday)
      obj.shippingDate = obj.shippingDate ? obj.shippingDate.replace(/-/g, "/") : ""
      obj.clientDate = new Date().toString();

      if (!obj.isResultMailSend) {
        obj.hospitalMail = ""
      }
      var isSw = this.isSW()
      for(const patient of obj.patientsData){
        patient.patientId = patient.patientId ? patient.patientId.replace(/^\s+/, "") : patient.patientId
        patient.age = patient.age + ""
        patient.birthday = patient.birthday ? patient.birthday.replace(/-/g, "/") :""
        patient.nextDate = patient.nextDate ? patient.nextDate.replace(/-/g, "/") : ""
        if(!isSw) {
          patient.beltSize = ""
          patient.attachedWaveform = ""
          patient.cannulaSize = ""
        }
      }
      if(obj.model != hstModelValue.WP300){
        obj.snoreSensor = false
      }
      obj.belongsId = this.belongsId
      // クイックオーダーのロジックを追加
      if(this.isApplicationValid){
        obj.preReceiptNumber = this.preReceiptNumber;
        obj.preKind = this.preKind
      }
      return client.apis.externalHst.setHstApplicationPOST({
        body:obj
      });
    },
    setHstApplicationPOSTSuccess: function(result) {
      // 成功メッセージ表示
      this.requestDate = result.obj.requestDate
      this.receiptNumber = result.obj.receiptNumber
      this.compleateFlg = true;
    },
    setHstApplicationPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    addressSearch: function(target,val){
      // 検索対象の郵便番号を設定
      this.searchTargetPostCode = val
      this.searchTargetAddress = null
      this.postCodeSearch().then(result=>{
        if (!this.searchTargetAddress) return; 
        if(target!="result"){
          this.reqParams.address = this.searchTargetAddress.prefecture + " " + this.searchTargetAddress.city + " " + this.searchTargetAddress.town
          this.reqParams.address1 = "";
          this.reqParams.address2 = "";

          // QA476 住所設定後フォーカスを移動する
          this.focusMove("address1");
          this.digitErrorPostcode = false;
        }else{
          this.reqParams.resultAddress = this.searchTargetAddress.prefecture + " " + this.searchTargetAddress.city + " " + this.searchTargetAddress.town
          this.reqParams.resultBuildingName = "";

          // QA476 住所設定後フォーカスを移動する
          this.focusMove("resultAddress");
          this.digitErrorResultPostcode = false;
        }
      })
    },
    patientAddressSearch: async function(index,val){
      // 検索対象の郵便番号を設定
      this.searchTargetPostCode = val
      this.searchTargetAddress = null
      await this.postCodeSearch().then(result=>{
        if (!this.searchTargetAddress) return;
        this.reqParams.patientsData[index].address = this.searchTargetAddress.prefecture + " " + this.searchTargetAddress.city + " " + this.searchTargetAddress.town
        this.reqParams.patientsData[index].address1 = "";
        this.reqParams.patientsData[index].address2 = "";

        // 再レンダリングの為、フラグ切替
        this.renderKey = !this.renderKey
      })
    },
    postCodeSearch: function(){
      var excuteApi = this.getAddressFromPostCodePOST;
      var successCallBack = this.getAddressFromPostCodePOSTSuccess;
      var errorCallBack = this.getAddressFromPostCodePOSTError;
      // WebAPI Call
      return this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getAddressFromPostCodePOST: function(client) {
      return client.apis.apiCommon.getAddressFromPostCodePOST({
        body:{
          postCode:this.searchTargetPostCode
        }
      });
    },
    getAddressFromPostCodePOSTSuccess: function(result) {
      this.searchTargetAddress = result.obj
      this.searchTargetPostCode = ""
    },
    getAddressFromPostCodePOSTError: function(result) {
      this.searchTargetPostCode = ""
    },
    getAgreementStr: async function() {
      var excuteApi = this.getConsentStatementPOST;
      var successCallBack = this.getConsentStatementPOSTSuccess;
      var errorCallBack = this.getConsentStatementPOSTError;
      // WebAPI Call
      await this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getConsentStatementPOST: function(client) {
      var type = this.consentStatement.hst_hospital;
      if(this.isDealer){
        type = this.consentStatement.hts_dealer;
      }
      return client.apis.apiCommon.getConsentStatementPOST({
        body: {
          type: type
        } 
      });
    },
    getConsentStatementPOSTSuccess: function(result) {
      if(result.body.contents != ""){
        this.agreement = result.body.contents;
        this.canAgree = true;
      } else {
        this.agreement = "利用規約が登録されていません。";
      }
    },
    getConsentStatementPOSTError: function(result) {
      this.agreement == "利用規約を取得できませんでした。";
    },
    getChoicesList: async function() {
      this.modelList = this.getChoiceList(this.choicesType.hstKind, false);
      this.desiredDeliveryTimeZoneList = this.getChoiceList(this.choicesType.deliveryTime, false);
      this.cannulaSizeList = this.getChoiceList(this.choicesType.cannulaSize, false);
      this.beltSizeList = this.getChoiceList(this.choicesType.beltSize, false);
      this.attachedWaveformList =  this.getChoiceList(this.choicesType.attachedWaveform, false);

      this.modelList.unshift({})
      this.desiredDeliveryTimeZoneList.unshift({})
      this.cannulaSizeList.unshift({})
      this.beltSizeList.unshift({})
      this.attachedWaveformList.unshift({})
    },
    getPreviousApplication: async function() {
      var excuteApi = this.getPreviousApplicationDetailsPOST;
      var successCallBack = this.getPreviousApplicationDetailsPOSTSuccess;
      var errorCallBack = this.getPreviousApplicationDetailsPOSTError;
      // WebAPI Call
      await this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getPreviousApplicationDetailsPOST: function(client) {
      return client.apis.apiCommon.getPreviousApplicationDetailsPOST({
        body: this.prevHstSearchParam
      });
    },
    getPreviousApplicationDetailsPOSTSuccess: function(result) {
      this.reqParams.doctorName = result.body.doctorName
    },
    getPreviousApplicationDetailsPOSTError: function(result) {
      // 取得失敗時
    },
    focusLostPatientFirstName: function(index) {
      if(!this.reqParams.patientsData[index].receiverName || this.reqParams.patientsData[index].receiverName==""){
        this.reqParams.patientsData[index].receiverName = this.reqParams.patientsData[index].patientFamilyName + " " + this.reqParams.patientsData[index].patientFirstName
        // 再レンダリングの為、フラグ切替
        this.renderKey = !this.renderKey
      }
    },
    getApplication: async function() {
      if(this.preKind == 'hst') {
        var excuteApi = this.getHstRequestDetailPOST;
        var successCallBack = this.getHstRequestDetailPOSTSuccess;
        var errorCallBack = this.getHstRequestDetailPOSTError;
        // WebAPI Call
        await this.apiCall(excuteApi, successCallBack, errorCallBack);
      } else if (this.preKind == 'psg') {
        var excuteApi = this.getAnalysisDetailPOST;
        var successCallBack = this.getAnalysisDetailPOSTSuccess;
        var errorCallBack = this.getAnalysisDetailPOSTError;
        // WebAPI Call
        await this.apiCall(excuteApi, successCallBack, errorCallBack);
      }
      else if (this.preKind == 'holter') {
        var excuteApi = this.getHolterRequestDetailPOST;
        var successCallBack = this.getHolterRequestDetailPOSTSuccess;
        var errorCallBack = this.getHolterRequestDetailPOSTError;
        // WebAPI Call
        await this.apiCall(excuteApi, successCallBack, errorCallBack);
      }
    },
    getHstRequestDetailPOST: function(client) {
      return client.apis.internalHst.getHstRequestDetailPOST({
        body:{
          receiptNumber:this.preReceiptNumber,
        }
      });
    },
    getHstRequestDetailPOSTSuccess: function(result) {
      this.isApplicationValid = true
      var obj = result.obj.applicationDetails

      // サーバーから取得した患者情報オブジェクトを取得
      var fromPatient = obj.patientsData[0]
      // 患者情報データの入力元オブジェクト
      var toPatient = this.reqParams.patientsData[0]

      // 施設紹介先からの遷移の場合は、医師名、事務担当者名、患者IDを繋ぎ込まない
      if(this.introduction){
        this.reqParams.doctorName = ""
        this.reqParams.clerkName = ""
        toPatient.patientId = ""
      }else{
        this.reqParams.doctorName = obj.doctorName
        this.reqParams.clerkName = obj.clerkName
        toPatient.patientId = fromPatient.patientId
      }

      var model = this.modelList.find(val => val.label1 && val.label1.match(/スリーププロファイラー/))
      
      if(this.preDeviceName){
        model = this.modelList.find(
          val => val.label1 && val.label1.match(new RegExp(this.preDeviceName))
        );
      }

      this.reqParams.model = model? model.value  + "": ""
      this.reqParams.delivaryTarget = obj.delivaryTarget

      if(this.reqParams.delivaryTarget == "hospital" && !this.introduction){
        this.reqParams.zip = obj.zip
        this.reqParams.address = obj.address
        this.reqParams.address1 = obj.address1
        this.reqParams.address2 = obj.address2
        this.reqParams.receiverName = obj.receiverName
        this.reqParams.phoneNumber = obj.phoneNumber
        this.reqParams.desiredDeliveryTimeZone = obj.desiredDeliveryTimeZone
      } else if (this.reqParams.delivaryTarget == "hospital" && this.introduction) {
        this.reqParams.delivaryTarget = "home"
      }

      // 患者情報
      toPatient.birthday = fromPatient.birthday ? fromPatient.birthday.replace(/\//g, "-") : ""
      toPatient.patientFamilyName = fromPatient.patientFamilyName
      toPatient.patientFirstName = fromPatient.patientFirstName
      toPatient.patientFamilyNameKana = fromPatient.patientFamilyNameKana
      toPatient.patientFirstNameKana = fromPatient.patientFirstNameKana
      toPatient.gender = fromPatient.gender
      toPatient.zip = fromPatient.zip
      toPatient.address = fromPatient.address
      toPatient.address1 = fromPatient.address1
      toPatient.address2 = fromPatient.address2
      toPatient.receiverName = fromPatient.receiverName
      toPatient.phoneNumber = fromPatient.phoneNumber

      this.changeModel();
    },
    getHstRequestDetailPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    getAnalysisDetailPOST: function(client) {
      return client.apis.externalAnalysis.getAnalysisDetailPOST({
        body:{
          receiptNumber:this.preReceiptNumber,
        }
      });
    },
    getAnalysisDetailPOSTSuccess: function(result) {
      this.isApplicationValid = true
      var obj = result.obj.requestDetails

      // 患者情報データの入力元オブジェクト
      var toPatient = this.reqParams.patientsData[0]

      // 施設紹介先からの遷移の場合は、医師名、事務担当者名、患者IDを繋ぎ込まない
      if(this.introduction){
        this.reqParams.doctorName = ""
        this.reqParams.clerkName = ""
        toPatient.patientId = ""
      }else{
        this.reqParams.doctorName = obj.doctorName
        this.reqParams.clerkName = obj.clerkName
        toPatient.patientId = obj.patientId
      }

      var model = this.modelList.find(val => val.label1 && val.label1.match(/スリーププロファイラー/))
      
      if(this.preDeviceName){
        model = this.modelList.find(
          val => val.label1 && val.label1.match(new RegExp(this.preDeviceName))
        );
      }

      this.reqParams.model = model? model.value  + "": ""

      // 患者情報
      toPatient.patientFamilyName = obj.patientFamilyName
      toPatient.patientFirstName = obj.patientFirstName
      toPatient.patientFamilyNameKana = obj.patientFamilyNameKana
      toPatient.patientFirstNameKana = obj.patientFirstNameKana
      toPatient.gender = obj.gender
      toPatient.birthday = obj.birthday ? obj.birthday.replace(/\//g, "-") : ""
      toPatient.age = ""

      this.changeModel();
    },
    getAnalysisDetailPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    getHolterRequestDetailPOST: function(client) {
      return client.apis.internalHolter.getHolterRequestDetailPOST({
        body:{
          receiptNumber:this.preReceiptNumber,
        }
      });
    },
    getHolterRequestDetailPOSTSuccess: function(result) {
      this.isApplicationValid = true
      var obj = result.obj.applicationDetails

      
      // サーバーから取得した患者情報オブジェクトを取得
      var fromPatient = obj.patientsData[0]
      // 患者情報データの入力元オブジェクト
      var toPatient = this.reqParams.patientsData[0]

      // 施設紹介先からの遷移の場合は、医師名、事務担当者名、患者IDを繋ぎ込まない
      if(this.introduction){
        this.reqParams.doctorName = ""
        this.reqParams.clerkName = ""
        toPatient.patientId = ""
      }else{
        this.reqParams.doctorName = obj.doctorName
        this.reqParams.clerkName = obj.clerkName
        toPatient.patientId = fromPatient.patientId
      }

      var model = this.modelList.find(val => val.label1 && val.label1.match(/スリーププロファイラー/))
      
      if(this.preDeviceName){
        model = this.modelList.find(
          val => val.label1 && val.label1.match(new RegExp(this.preDeviceName))
        );
      }

      this.reqParams.model = model? model.value  + "": ""
      this.reqParams.delivaryTarget = obj.delivaryTarget

      if(this.reqParams.delivaryTarget == "hospital" && !this.introduction){
        this.reqParams.zip = obj.zip
        this.reqParams.address = obj.address
        this.reqParams.address1 = obj.address1
        this.reqParams.address2 = obj.address2
        this.reqParams.receiverName = obj.receiverName
        this.reqParams.phoneNumber = obj.phoneNumber
        this.reqParams.desiredDeliveryTimeZone = obj.desiredDeliveryTimeZone
      } else if (this.reqParams.delivaryTarget == "hospital" && this.introduction) {
        this.reqParams.delivaryTarget = "home"
      }

      // 患者情報
      toPatient.birthday = fromPatient.birthday ? fromPatient.birthday.replace(/\//g, "-") : ""
      toPatient.patientFamilyName = fromPatient.patientFamilyName
      toPatient.patientFirstName = fromPatient.patientFirstName
      toPatient.patientFamilyNameKana = fromPatient.patientFamilyNameKana
      toPatient.patientFirstNameKana = fromPatient.patientFirstNameKana
      toPatient.gender = fromPatient.gender
    
      //院内貸出の場合、住所を繋ぎ込まない
      if(obj.depositMachineFlag){
        toPatient.zip = ""
        toPatient.address = ""
        toPatient.address1 = ""
        toPatient.address2 = ""
        toPatient.receiverName = ""
      }else{
        toPatient.zip = fromPatient.zip
        toPatient.address = fromPatient.address
        toPatient.address1 = fromPatient.address1
        toPatient.address2 = fromPatient.address2
        toPatient.receiverName = fromPatient.receiverName
      }

      toPatient.phoneNumber = fromPatient.phoneNumber

      this.changeModel();
    },
    getHolterRequestDetailPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    /**
     * QA476 郵便番号からフォーカスが外れたら桁数に応じて桁数判定フラグを設定する
     * @param zipCode 郵便番号
     * @param flagName 桁数判定フラグ
     */
    onZipBlur(zipCode, flagName) {
      if (flagName !== null && typeof flagName === "object" && !Array.isArray(flagName)) {
        flagName.digitErrorPatientPostcode = zipCode.length < 7;
      }else {
        this[flagName] = zipCode.length < 7;
      }
    },
    /**
     * QA476 引数に指定した項目の末尾にフォーカスを移動する
     * @param refName フォーカスをあてる項目定義
     */
    focusMove(refName) {
      this.$nextTick(() => {
        const element = this.$refs[refName];
        if (element) {
          element.focus();
          const length = element.value.length;
          element.setSelectionRange(length, length);
        }
      })
    },
    setupZipWatchers() {
      this.reqParams.patientsData.forEach((item, index) => {
        this.$watch(() => item.zip,
          async (newZip, oldZip) => {
            if (newZip === oldZip) return;
            // 何も入ってないまたは7桁未満なら何もしない
            if (!newZip || newZip.length !== 7) return;
            if (isNaN(Number(newZip))) return;

            // 住所検索
            await this.patientAddressSearch(index, newZip);

            // 検索後に住所欄へフォーカス
            this.$nextTick(() => {
              var address1 = document.getElementById(`address1_${index}`);
              address1.focus();
            });
          }
        );
      });
    }
  },
  data() {
    var preReceiptNumber = this.$route.params["receiptNumber"];
    var preKind = this.$route.params["kind"];
    var preDeviceName = this.$route.params["deviceName"];
    var introduction = this.$route.params["introduction"];
    var oneClickModel = this.$route.params["oneClickModel"];
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var roleId = userInfo.roleId;
    var userId = userInfo.id;
    var miniday = new Date()
    var maxDate = new Date()
    maxDate.setDate(maxDate.getDate() + 365);
    var maxday = new Date(maxDate.getFullYear(), maxDate.getMonth(), maxDate.getDate());
    var isDealer = roleId == role.role_dealer;
    var isSalesOffice = roleId == role.role_salesOffice;
    var isHospital = roleId == role.role_hospital;
    var isHonsha = roleId == role.role_headOffice;
    var isAdmin = roleId == role.role_admin;
    var serviceId = service.hst;
    return {
      role: role,
      roleId: roleId,
      userId: userId,
      userInfo: userInfo,
      choicesType:choicesType,
      extUserStatus: extUserStatus,
      belongsId:userInfo.belongsId,
      lendingPeriod:LendingPeriod.period,
      organizationModalActive: false,
      isChecked: false,
      agreement: "",
      activeStep: 0,
      isHospitalAgree: roleId != role.role_dealer,
      isDealer: isDealer,
      isSalesOffice: isSalesOffice,
      isHonsha: isHonsha,
      isAdmin: isAdmin,
      miniday: miniday,
      maxday:maxday,
      disabledDays: [],
      reqParams: {
        isDealer: isDealer,
        hospitalName: isHospital ? userInfo.medicalInstitutionName + " " + userInfo.departmentName : "",
        doctorName: "",
        clerkName:"",
        isResultMailSend:false,
        hospitalMail:"",
        zip:isHospital ? userInfo.postcode : "",
        address:isHospital ? userInfo.prefecture + " " + userInfo.city : "",
        address1:isHospital ? userInfo.address : "",
        address2:isHospital ? userInfo.building : "",
        receiverName:"",
        phoneNumber:isHospital ? userInfo.phoneNumber : "",
        desiredDeliveryTimeZone:"",
        resultZip:"",
        resultAddress:"",
        resultBuildingName:"",
        resultCompanyName:"",
        resultDivision:"",
        resultReceiverName:"",
        resultPhoneNumber:"",
        model:"",
        snoreSensor:false,
        delivaryTarget:"home",
        demo:false,
        returnDate:"",
        shippingDate:null,
        deliverySlip:false,
        institutionId: "",
        patientsData: [{ ...initialPatientValue }],
      },
      compleateFlg:false,
      searchTargetPostCode:"",
      searchTargetAddress:null,
      requestDate:"",
      receiptNumber:"",
      renderKey:true,
      officeCalenderActive: false,
      needAgree: roleId == role.role_hospital || roleId == role.role_dealer,
      canAgree:false,
      consentStatement:consentStatement,
      modelList:[],
      modelListLinkedEstimate:[],
      desiredDeliveryTimeZoneList:[],
      cannulaSizeList:[],
      beltSizeList:[],
      attachedWaveformList:[],
      prevHstSearchParam:{
        kind:this.$route.params["kind"]?this.$route.params["kind"]:'hst',
        belongsId:userInfo.belongsId,
        institutionId:0,
        fullFlag:false
      },
      isHospital,
      preReceiptNumber,
      preKind,
      preDeviceName,
      introduction,
      earliestShippingDate: "",
      // 半角数字エラーメッセージ表示
      invalidDeviceDestinationPostcode: false,
      invalidDeviceDestinationPhoneNumber: false,
      invalidResultDestinationPostcode: false,
      invalidResultDestinationPhoneNumber: false,
      note:"",
      serviceId,
      disabledSnoreSensor: true,
      estimateSnoreSensorState: 0,
      isApplicationValid: false,
      digitErrorZipMessage,
      digitErrorPostcode:false,
      digitErrorResultPostcode:false,
      isInitialZip:false,
      isInitialResultZip:false,
      oneClickModel:oneClickModel,
    };
  },
  components: {
    organizationSelectModal:OrganizationSelectModal,
    facilitySelectModal:FacilitySelectModal,
    hstRequestDetail: hstRequest,
    officeCalenderModal:OfficeCalenderModal
  },
  async mounted() {
    //同意文取得
    await this.getAgreementStr();
    // 機種マスタ取得
    await this.getChoicesList();

    if(this.isHospital){
      // 見積りコードが紐づいた機種を取得・設定
      await this.getChoicesListLinkedEstimate()
      if(this.preReceiptNumber) {
      	await this.getApplication();
      } else {
        // 前回申込み情報の取得
        await this.getPreviousApplication()
      }
    }
    if(this.oneClickModel){
      this.reqParams.model = this.oneClickModel
      await this.changeModel()
    }
    
    this.setupZipWatchers();
  },
  computed: {
    // 半角数字エラーテンプレートメッセージ
    invalidNumberMessage() {
      return invalidNumberMessage;
    },
    // 郵便番号入力におけるプレースフォルダー
    postcodePlaceholder() {
      return postcodePlaceholder;
    },
    // 電話番号入力におけるプレースフォルダー
    phonePlaceholder() {
      return phonePlaceholder;
    },
  },
  watch: {
    "reqParams.zip"(newValue) {
      this.invalidDeviceDestinationPostcode = isNaN(Number(newValue));
      // QA476 郵便番号自動検索処理
      if (this.isInitialZip) {
        this.isInitialZip = false;
        return
      }
      if (!this.invalidDeviceDestinationPostcode && newValue.length === 7) {
        this.addressSearch('device', newValue);
      }
    },
    "reqParams.phoneNumber"(newValue) {
      this.invalidDeviceDestinationPhoneNumber = isNaN(Number(newValue));
    },
    "reqParams.resultZip"(newValue) {
      this.invalidResultDestinationPostcode = isNaN(Number(newValue));
      // QA476 郵便番号自動検索処理
      if (this.isInitialResultZip) {
        this.isInitialResultZip = false;
        return
      }
      if (!this.invalidResultDestinationPostcode && newValue.length === 7) {
        this.addressSearch('result', newValue);
      }
    },
    "reqParams.resultPhoneNumber"(newValue) {
      this.invalidResultDestinationPhoneNumber = isNaN(Number(newValue));
    },
    "reqParams.patientsData": {
      handler(newValue) {
        newValue.map((value) => {
          value.invalidPostcode = isNaN(Number(value.zip));
          value.invalidPhoneNumber = isNaN(Number(value.phoneNumber));
        });
      },
      deep: true,
    }
  },
};
</script>

<style>
</style>
<style lang="scss" scoped>
.shippingDate {
  width: 150px  !important;
}
.snoreSensorCheckBox {
  opacity: 0.25 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/guest/HSTRequest.vue